import { useEffect, useRef, useState } from "react";
import useCountUp from "./useCountUp";

/** Scroll count-up; optional live ticks for dashboard-style stats (e.g. %91 RCA). */
export default function useLiveStatCounter(
  target,
  duration = 1600,
  { min = 90, max = 92, intervalMs = 4200, enabled = false } = {}
) {
  const { ref, display } = useCountUp(target, duration);
  const [shown, setShown] = useState(display);
  const liveTimer = useRef(null);

  useEffect(() => {
    setShown(display);
  }, [display]);

  useEffect(() => {
    if (!enabled) return undefined;

    const prefix = String(target).match(/^[^0-9]*/)?.[0] ?? "";
    const boot = setTimeout(() => {
      liveTimer.current = setInterval(() => {
        const n = min + Math.floor(Math.random() * (max - min + 1));
        setShown(`${prefix}${n}`);
      }, intervalMs);
    }, duration + 400);

    return () => {
      clearTimeout(boot);
      if (liveTimer.current) clearInterval(liveTimer.current);
    };
  }, [target, duration, min, max, intervalMs, enabled]);

  return { ref, display: enabled ? shown : display };
}
